import { FieldType, IRiskTemplate } from 'types/graphql'

export const generateRowInitialValue = (fieldType: FieldType) => {
  switch (fieldType) {
    case FieldType.Switch: {
      return false
    }
    default:
      return null
  }
}

type ColumnInfo = { position: number; height: number }

export const findPrevColumns = (
  map: Record<string, ColumnInfo>,
  grouped: { fieldLinkId: string; groupedBy: string[] }[],
  targetId: string
): ColumnInfo[] => {
  const target = map[targetId]

  if (!target) {
    return []
  }

  const getChildren = (id: string) => grouped.filter((x) => x.groupedBy?.includes(id)).map((x) => x.fieldLinkId)

  const targetChildrenSet = new Set(getChildren(targetId))

  return Object.entries(map)
    .filter(([id, value]) => {
      if (id === targetId || value.position > target.position) {
        return false
      }

      const children = getChildren(id)

      return children.some((childId) => targetChildrenSet.has(childId))
    })
    .map(([, value]) => value)
}

export type GroupingMapItem = {
  fieldLinkId: string
  groupedBy: string[]
}

export const buildGroupingMap = (riskTemplate: IRiskTemplate, tableFieldId: string): GroupingMapItem[] => {
  const tableColumns = riskTemplate.fieldLinks.filter((item) => item.parentFieldId === tableFieldId && item.primary)

  const entityIdToPrimaryFieldLinkId = new Map<string, string>()

  for (const link of tableColumns) {
    entityIdToPrimaryFieldLinkId.set(link.field.entityId, link.id)
  }

  return tableColumns.map((fieldLink) => {
    const parents = new Set<string>()

    for (const fg of fieldLink.fieldGroups ?? []) {
      const parentFieldLinkId = entityIdToPrimaryFieldLinkId.get(fg.groupedByEntityId)

      if (parentFieldLinkId && parentFieldLinkId !== fieldLink.id) {
        parents.add(parentFieldLinkId)
      }
    }

    return {
      fieldLinkId: fieldLink.id,
      groupedBy: Array.from(parents)
    }
  })
}
